'use strict';

import videoFilesTemplate from './videoFiles.html';

export const videoFilesDirName = 'videoFiles';
export function videoFilesDir() {
  return {
    restrict: 'E', 
    template: videoFilesTemplate,
    scope: {
      files: '=',
      activeVideoFile: '&',
      playFile: '&',
      showLabels: '='
    },
    compile: (ele, attrs) => {
      attrs.showLabels = attrs.showLabels || true;
    }
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/videoFiles/videoFiles.js